import { useRecoilValue } from 'recoil'
import { appInterface, useIsAppControl } from '@store/isApp'
import { useDarkModeControl } from '@hooks/useDarkModeControl'

interface HandleEventProps {
	/** 색상 : hexcode */
	color: string
	/** 다크 테마 여부 */
	isDark?: boolean
	/** 투명도 */
	opacity?: number
}

const useDimmed = () => {
	const { isApp, appInfo } = useIsAppControl()
	const { darkMode } = useDarkModeControl()
	const nativeEvent = useRecoilValue(appInterface)

	/** 커스텀 dimmed 설정 */
	const setDimmed = ({ color, isDark, opacity = 1 }: HandleEventProps) => {
		if (!isApp) {
			return
		}

		nativeEvent({
			key: 'dimmed',
			value: {
				hexcode: color,
				isDark: isDark || darkMode,
				opacity,
			},
		})
	}

	/** 기기별 dimmed 설정 */
	const setDimmedForDeviceType = ({ opacity = 0.7 }: Pick<HandleEventProps, 'opacity'>) => {
		if (appInfo?.DType === 'I') {
			setDimmed({ color: darkMode ? '242424' : 'ffffff', opacity })
		} else if (appInfo?.DType === 'A') {
			setDimmed({
				color: darkMode ? '101010' : '000000',
				isDark: true,
				opacity: darkMode ? 1 : opacity,
			})
		}
	}

	/** 기본 dimmed 설정 (보통 라우트 이동시에 사용됨) */
	const setDefaultDimmed = () => {
		setDimmed({ color: darkMode ? '242424' : 'ffffff' })
	}

	return {
		setDimmed,
		setDefaultDimmed,
		setDimmedForDeviceType,
	}
}
export default useDimmed
